import React from 'react'
import { inject, observer } from 'src/core/store'
import './index.less'
import { setDocumentTitle, setUidToken } from 'src/helper/tool'
import { jumpToUser } from 'src/helper/webviewFun'
import lang from './lang'
import { getlang, setlang } from 'src/helper/getlang'
import ReminderBtn from 'src/component/myRuleButton'
import Message from '../../../component/Message'
import http from 'src/helper/http'
import score from "src/helper/score";
import { history } from 'src/core/router'
@inject('store')
@observer
export default class Couples extends React.Component {
  constructor(props) {
    super(props)
  }
  state = {
    lang: lang.en,
    language: 'en',
    minute: 0,
    day: 0,
    hour: 0,
    second: 0,
    topReward: [],
    topHighList: [],
    myRanking: {},
    rankingList: [],
    voteReward: [],
    myInfo: {},
    showIn: 0,
    boxIndex: 0,
    eidRewardList:[],
    selectRewardIndex:0,
    rankingGiftList:[],
    rankRewardList:{},
    lostRankingList:[],
    mine:{},
    uidInfo:{},
  }

  async componentDidMount() {
    let { language } = this.props.location.query
    const uid = await setUidToken(this.props.location.query)
    language = await getlang(language)
    if (language == 'ar') {
      setDocumentTitle('عيد الفطر')
    } else if (language == 'tr') {
      setDocumentTitle("Ramazan Bayramı")
    } else {
      setDocumentTitle('eid al-fitr')
    }
    this.setState({
      lang: setlang(language, lang),
      language: language,
      uid,
    })
    this.getCountDownTime()
    this.getEidReward()
    this.getRankingGiftList()
    this.getRankList()
    this.getRankReward()
  }

  countDown = (times = 2299085) => {
    let { lang } = this.state
    var timer = null
    timer = setInterval(() => {
      var day = 0,
        hour = 0,
        minute = 0,
        second = 0
      if (times > 0) {
        day = Math.floor(times / (60 * 60 * 24))
        hour = Math.floor(times / (60 * 60)) - day * 24
        minute = Math.floor(times / 60) - day * 24 * 60 - hour * 60
        second = Math.floor(times) - day * 24 * 60 * 60 - hour * 60 * 60 - minute * 60
      }
      if (day <= 9) day = day
      if (hour <= 9) hour = '0' + hour
      if (minute <= 9) minute = '0' + minute
      if (second <= 9) second = '0' + second
      let daystr = ''
      if (day > 0) {
        // daystr = day
        daystr = day + ' ' + lang.days
      }
      this.setState({
        minute,
        day,
        hour,
        second
      })
      times--
    }, 1000)
    if (times <= 0) {
      clearInterval(timer)
    }
  }

  getCountDownTime = async () => {
    let nowTime = Math.floor(new Date().getTime() / 1000)
    let res = await http.post('/web/eid/timeinfo')
    if (nowTime > res.res.beginTimestamp) {
      this.countDown(res.res.leftTimestamp)
    }
  }

  getEidReward = async ()=>{
    let res = await http.post('/web/eid/rechargerewardlist')
    if (res.code == 0 ) {
      this.setState({
        eidRewardList:res.res
      })
    }
    this.getUserInfoWeb()
  }

  getRankingGiftList = async()=>{
    let res = await http.post('/web/eid/giftlist')
    if (res.code == 0 ) {
      this.setState({
        rankingGiftList:res.res
      })
    }
  }

  getRankList = async()=>{
    let res = await http.post('/web/eid/rank')
    if (res.code == 0 ) {
      this.setState({
        rankingList:res.res.list,
        lostRankingList:res.res.list.length>3?res.res.list.slice(3,res.res.list.length):[],
        mine:res.res.mine || {},
      })
    } 
  }
  
  getUserInfoWeb = async(uid)=> {
    let d = await http.post('/web/MyAccountInfo', { uid: uid })
    if (d && d.code == 0 ) {
      this.setState({
        uidInfo:d.res
      })
    }
  }
  getDepositBonus = async(cb)=>{
    let { boxIndex, selectRewardIndex, lang } = this.state
    let res = await http.post('/web/eid/getrechargereward',{ id:boxIndex+1, rewardId:selectRewardIndex+1})
    if (res.code == 0 ) {
      this.refs.msg.show(lang.sesmsg)
    }
    this.getEidReward()
    cb && cb()
    
  }
  
  getRankReward = async()=>{
    let res = await http.post('/web/eid/rankrewardlist')
    if (res.code == 0) {
      this.setState({
        rankRewardList:res.res
      })
    }
  }

  showRulesModle = (open, close) => {
    let { lang } = this.state
    return (
      <div className="eid-activities-modle" >
        <div className='title-tip'>{lang.rule}</div>
        <div className="eid-activities-modle-body" onClick={() => close()}>
          <div
            className="ru-show-toot"
            dangerouslySetInnerHTML={{ __html: lang ? lang.rulesDeil : '' }}
          ></div>
        </div>
      </div>
    )
  }

  showViewBoxModle = (open, close) => {
    let { lang, boxIndex, eidRewardList, language } = this.state
    return (
      <div className="eid-activities-modle" >
        <div className='title-tip'>{boxIndex == 0?lang.rechOne:boxIndex == 1?lang.rechTwo:lang.rechThree}</div>
        <div className='' style={{height:'1.51rem'}}></div>
        <div className="show-box-body" onClick={() => close()} style={{overflowY:'clip'}}>
           <div className='show-box-item'>
           { eidRewardList.length>0 && eidRewardList[boxIndex] && eidRewardList[boxIndex].Reward1.map((item,index)=>(<div className='reward-item' key={index}>
              <div className='gift-img'>
                <img className='gift-img-atr' src={language=='tr'?item.picTr ||item.pic :language=='ar'?item.picAr ||item.pic :item.pic}></img>
                {item.rewardType!='gold' && item.rewardType!='ruby' &&  <div className='gift-time'><div>{language == 'ar' ? item.rewardNum + 'يوم' : language == 'tr' ? item.rewardNum + 'Gün' : item.rewardNum + 'day'}</div></div>}
              </div>
              <div className='gift-name'>{language=='tr'?item.rewardNameTr ||item.rewardName :language=='ar'?item.rewardNameAr ||item.rewardName :item.rewardName}</div>
            </div>))}
          </div>
          <div className='or-tip'>Or</div>
          <div className='show-box-item'>
          {eidRewardList.length>0 && eidRewardList[boxIndex] && eidRewardList[boxIndex].Reward2.map((item,index)=>(<div className='reward-item' key={10+index}>
              <div className='gift-img'>
                <img className='gift-img-atr'  src={language=='tr'?item.picTr ||item.pic :language=='ar'?item.picAr ||item.pic :item.pic}></img>
                {item.rewardType!='gold' && item.rewardType!='ruby' &&  <div className='gift-time'><div>{language == 'ar' ? item.rewardNum + 'يوم' : language == 'tr' ? item.rewardNum + 'Gün' : item.rewardNum + 'day'}</div></div>}
              </div>
              <div className='gift-name'>{language=='tr'?item.rewardNameTr ||item.rewardName :language=='ar'?item.rewardNameAr ||item.rewardName :item.rewardName}</div>
            </div>))}
          </div>
        </div>
      </div>
    )
  }

  showGetBoxReModal = (open, close) => {
    let { lang, boxIndex, eidRewardList, selectRewardIndex, language  } = this.state
    return (
      <div className="eid-activities-modle" >
        <div className='title-tip'>{boxIndex == 0?lang.rechOne:boxIndex == 1?lang.rechTwo:lang.rechThree}</div>
        <div className="get-rew-modal-body">
        <div className={`show-box-item ${selectRewardIndex == 0 ?'in-select-reward':'on-select-reward'}`} onClick={()=>this.handleSelectWhichOne(0)}>
        { eidRewardList.length>0 && eidRewardList[boxIndex] && eidRewardList[boxIndex].Reward1.map((item,index)=>(<div className='reward-item' key={index}>
              <div className='gift-img'>
                <img className='gift-img-atr'  src={language=='tr'?item.picTr ||item.pic :language=='ar'?item.picAr ||item.pic :item.pic}></img>
                {item.rewardType!='gold' && item.rewardType!='ruby' &&  <div className='gift-time'><div>{language == 'ar' ? item.rewardNum + 'يوم' : language == 'tr' ? item.rewardNum + 'Gün' : item.rewardNum + 'day'}</div></div>}
              </div>
              <div className='gift-name'>{language=='tr'?item.rewardNameTr ||item.rewardName :language=='ar'?item.rewardNameAr ||item.rewardName :item.rewardName}</div>
            </div>))}
            {selectRewardIndex == 0  && <img className='handle-select-reward' src='/img/activity/eid-activities/yes_icon.png' ></img>}
        </div>
        <div className={`show-box-item ${selectRewardIndex == 1 ?'in-select-reward':'on-select-reward'}`} style={{marginTop:'0.14rem'}}  onClick={()=>this.handleSelectWhichOne(1)}>
        { eidRewardList.length>0 && eidRewardList[boxIndex] && eidRewardList[boxIndex].Reward2.map((item,index)=>(<div className='reward-item' key={20+index}>
              <div className='gift-img'>
                <img className='gift-img-atr'  src={language=='tr'?item.picTr ||item.pic :language=='ar'?item.picAr ||item.pic :item.pic}></img>
                {item.rewardType!='gold' && item.rewardType!='ruby' &&  <div className='gift-time'><div>{language == 'ar' ? item.rewardNum + 'يوم' : language == 'tr' ? item.rewardNum + 'Gün' : item.rewardNum + 'day'}</div></div>}
              </div>
              <div className='gift-name'>{language=='tr'?item.rewardNameTr ||item.rewardName :language=='ar'?item.rewardNameAr ||item.rewardName :item.rewardName}</div>
            </div>))}
           {selectRewardIndex == 1  && <img className='handle-select-reward' src='/img/activity/eid-activities/yes_icon.png' ></img>}
        </div>
        <div className='get-btn' onClick={ ()=>{ this.getDepositBonus(close)}}>{lang.getText}</div>
        </div>
      </div>
    )
  }

  showRankingRewardModal = (open, close) => {
    let { lang, boxIndex, İlk, rankRewardList, language } = this.state
    return (
      <div className="eid-activities-modle" >
        <div className='title-tip'>{lang.rewards}</div>
        <div className='' style={{height:'1.51rem'}}></div>
        <div className="show-box-body" onClick={() => close()}>
         {Object.keys(rankRewardList).length>0 && Object.keys(rankRewardList).map((item,index)=>(
          <div key={index}>
          {index!=3 && <div className='or-tip'>{language == 'tr'?'İlk':'Top'}{index+1}</div>}
          <div className='show-box-item'>
          {rankRewardList[`rankReward${index+1}`] && rankRewardList[`rankReward${index+1}`].length>0 && rankRewardList[`rankReward${index+1}`].map((item,index)=>(<div className='reward-item' key={index}>
              <div className='gift-img'>
                <img className={`${item.rewardType == 'custom_flash'?'':"gift-img-atr"}`} style={{maxHeight:`${item.rewardType == 'custom_flash'?'0.91rem':""}`}} src={language=='tr'?item.picTr ||item.pic :language=='ar'?item.picAr ||item.pic :item.pic}></img>
                <div className='gift-time'><div>{language == 'ar' ? item.rewardNum + 'يوم' : language == 'tr' ? item.rewardNum + 'Gün' : item.rewardNum + 'day'}</div></div>
              </div>
              <div className='gift-name'>{language=='tr'?item.rewardNameTr ||item.rewardName :language=='ar'?item.rewardNameAr ||item.rewardName :item.rewardName}</div>
            </div>))}
          </div>
          </div>
         ))}
        </div>
      </div>
    )
  }

  selectOnShow = (e) => {
    this.setState({
      showIn: e
    })
  }

  viewBox = (e) => {
    this.setState({ boxIndex: e})
  }
  
  handleSelectWhichOne= (e)=>{
    this.setState({ selectRewardIndex:e })
  }

  render() {
    let { language, lang, day, hour, second, minute, showIn, eidRewardList, rankingGiftList,  rankingList, lostRankingList, uidInfo, mine } = this.state
    return (
      <div className={`eid-activities ${language == 'ar' ? 'arlang' : ''}`} >
        
        <div className='banner-activities'>
          <img className='light-root' src='/img/activity/eid-activities/move_gif.gif'></img>
          <ReminderBtn
            lang={lang}
            slotButtonComp={() => {
              return <div className={`eid-activities-ranking-reward ${showIn ==1?'moveOn':'liveOn'}`}>{lang.rewards}</div>
            }}
            slotContentComp={this.showRankingRewardModal}
          />
          <ReminderBtn
            lang={lang}
            slotButtonComp={() => {
              return <div className="eid-activities-rules">{lang.rule}</div>
            }}
            slotContentComp={this.showRulesModle}
          />
          <div  className='title-time-root' >
            {language == 'en' && <img className='ar-bg' src='/img/activity/eid-activities/time_period_en.png'></img>}
            {language == 'ar' && <img className='ar-bg' src='/img/activity/eid-activities/time_period_ar.png'></img>}
            {language == 'tr' && <img className='ar-bg' src='/img/activity/eid-activities/time_period_tr.png'></img>}
            {false && <div className='title-tip'>4/10 00:00-4/29 00:00</div>}
          </div>
          <img src='/img/activity/eid-activities/noe_line.png' className='btm-root-tp-img'></img>
          <div className='btm-root'>
            <div className='time-num-root'>
              <div className='days num'>{day}</div>
              <div className='days-title'>{lang.days}</div>
              <div className='hour num'>{hour}</div>
              <div className='oew-ewp'>:</div>
              <div className='min num'>{minute}</div>
              <div className='oew-ewp'>:</div>
              <div className='second num'>{second}</div>
            </div>
          </div>
          <img src='/img/activity/eid-activities/noe_line.png' className='btm-root-bm-img'></img>
        </div>
        <div className='select-show-how'>
          <div className={`${showIn == 0 ? 'in-select' : 'no-select'}`} onClick={() => this.selectOnShow(0)}>{lang.rechargeRewards}</div>
          <div className={`${showIn == 1 ? 'in-select' : 'no-select'}`} onClick={() => this.selectOnShow(1)}>{lang.ranking}</div>
        </div>
        {showIn == 0 && <div className='reward-root'>
          <div className='reward-title'>{lang.newTtile}</div>
          <div className='show-reward'>
            <div className='show-reward-tip'>{lang.wantTo}</div>
            <div className='show-reward-item'>
              <div className='item'>
                <ReminderBtn
                  lang={lang}
                  slotButtonComp={() => {
                    return <div className='treasure-chest-one' onClick={() => this.viewBox(0)}>$50</div>
                  }}
                  slotContentComp={this.showViewBoxModle}
                />
                {eidRewardList[0]&& eidRewardList[0].rewardNum == 0 &&  <div className='get-btn-no'>{lang.getText}</div>}
                {eidRewardList[0]&& eidRewardList[0].rewardNum > 0 && <ReminderBtn
                  lang={lang}
                  slotButtonComp={() => {
                    return <div className='get-btn' onClick={() => this.viewBox(0)} >{lang.getText} <div className='can-get-num' >{eidRewardList[0].rewardNum}</div></div>
                  }}
                  slotContentComp={this.showGetBoxReModal}
                />}
              </div>
              <div className='item'>
              <ReminderBtn
                  lang={lang}
                  slotButtonComp={() => {
                    return  <div className='treasure-chest-two' onClick={() => this.viewBox(1)}>$100</div>
                  }}
                  slotContentComp={this.showViewBoxModle}
                />
                {eidRewardList[1]&& eidRewardList[1].rewardNum == 0 &&  <div className='get-btn-no'>{lang.getText}</div>}
                {eidRewardList[1]&& eidRewardList[1].rewardNum > 0 && <ReminderBtn
                  lang={lang}
                  slotButtonComp={() => {
                    return <div className='get-btn'  onClick={() => this.viewBox(1)}>{lang.getText} <div className='can-get-num'>{eidRewardList[1].rewardNum}</div></div>
                  }}
                  slotContentComp={this.showGetBoxReModal}
                />}
              </div>
              <div className='item'>
              <ReminderBtn
                  lang={lang}
                  slotButtonComp={() => {
                    return <div className='treasure-chest-three' onClick={() => this.viewBox(2)}>$200</div>
                  }}
                  slotContentComp={this.showViewBoxModle}
                />
                {eidRewardList[2]&& eidRewardList[2].rewardNum == 0 &&  <div className='get-btn-no'>{lang.getText}</div>}
                {eidRewardList[2]&& eidRewardList[2].rewardNum > 0 && <ReminderBtn
                  lang={lang}
                  slotButtonComp={() => {
                    return <div className='get-btn'  onClick={() => this.viewBox(2)}>{lang.getText} <div className='can-get-num'>{eidRewardList[2].rewardNum}</div></div>
                  }}
                  slotContentComp={this.showGetBoxReModal}
                />}
              </div>
            </div>
          </div>
        </div>}
        {showIn == 0 && <div className='reward-root'>
          <div className='reward-title'>{lang.modeAit}</div>
          <div className='show-reward'>
            <div className='show-reward-tip'>{lang.moAct}</div>
            <img className='other-activity' src={`/img/activity/eid-activities/recharge_${language}.png`} onClick={()=>history.push('activity/goldRubyRecharge')}></img>
          </div>
        </div>}
        {showIn == 1 && <div className='reward-root'>
          <div className='reward-title'>{lang.giftText}</div>
          <div className='show-reward'>
            <div className='show-reward-tip'>{lang.giftranktip}</div>
            <div className='show-reward-item'>
              {rankingGiftList.length>0 && rankingGiftList.map((item,index)=>(<div className='gift-item' key={index}>
                <div className='gift-img'>
                  <img className='gift-img-atr' src={item.image}></img>
                </div>
                <div className='gift-name'>{item.name}</div>
                <div className='gift-price'>{item.gold}<img src='/img/app/ruby/icon_coin_gold-new.png'></img></div>
              </div>))}

            </div>
          </div>
        </div>}
        {showIn == 1 && <div className='ranking-root'>
          <div className='ranking-title'>{lang.ranking}</div>
          <div className='ranking-list-root'>
            {rankingList.length>0 && rankingList[0] && <div className='top-one-root'>
              <img className='top-root-bg' src='/img/activity/eid-activities/top_one_bg.png'></img>
              <img className='user-img' src={rankingList[0].avatarurl} onClick={()=>jumpToUser(rankingList[0].uid)}></img>
              <div className='user-name'>{rankingList[0].nickname}</div>
              <div className='user-ranking-num'>{score(rankingList[0].score)}</div>
            </div>}
            {rankingList.length>1 && rankingList[1] && <div className='top-two-root'>
              <img className='top-two-root-bg' src='/img/activity/eid-activities/top_two_bg.png'></img>
              <img className='user-img' src={rankingList[1].avatarurl} onClick={()=>jumpToUser(rankingList[1].uid)}></img>
              <div className='user-name'>{rankingList[1].nickname}</div>
              <div className='user-ranking-num'>{score(rankingList[1].score)}</div>
            </div>}
            {rankingList.length>2 && rankingList[2] &&<div className='top-three-root'>
              <img className='top-three-root-bg' src='/img/activity/eid-activities/top_three_bg.png'></img>
              <img className='user-img' src={rankingList[2].avatarurl} onClick={()=>jumpToUser(rankingList[2].uid)}></img>
              <div className='user-name'>{rankingList[2].nickname}</div>
              <div className='user-ranking-num'>{score(rankingList[2].score)}</div>
            </div>}
            <div className='ranking-item-root'>
              {lostRankingList.length> 0 && lostRankingList.map((item, index) => (<div className='last-ranking-item' key={index}>
                <div className={language == 'ar'?'last-ranking-img-ar':'last-ranking-img'}  style={{transform:'rotate(180edg)'}}></div>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <div className={language == 'ar'?'top-num-ar':'top-num'}>{item.rankIdx}</div>
                  <div className='user-info'  >
                    <div className='user-atv' style={{marginRight:`${language == 'ar'?'0':'0.23rem'}`}}>
                      <img className='user-atv-bg' src='/img/activity/eid-activities/lost_ranking_bg.png'></img>
                      <img className='user-img' src={item.avatarurl} onClick={()=>jumpToUser(item.uid)}></img>
                    </div>
                    <div className='user-name-id'>
                      <div className='name'>{item.nickname}</div>
                      <div className='user-id'>ID: {item.duid}</div>
                    </div>
                  </div>
                </div>
                <div className='ranking-num' style={{marginRight:`${language=='ar'?'':'0.69rem'}`,marginLeft:`${language=='ar'?'0.69rem':''}`}}>
                  <div className='num'>{score(item.score)}</div>
                  <img className='num-icon' src='/img/app/ruby/icon_coin_gold-new.png'></img>
                </div>
              </div>))}
            </div>
          </div>
        </div>}
        {showIn == 1 && <div className='my-ranking-card'>
          <div className='my-ranking-card-left'>
           <div className='my-ranking-num'>{mine.rankIdx || '--'}</div>
           <div className='my-ranking-info'>
            <div className='my-info-img'>
              <img className='user-avatarurl-bg' src='/img/activity/eid-activities/lost_ranking_bg.png'></img>
              <img className='user-avatarurl' src={uidInfo.avatarurl}></img>
            </div>
            <div className='my-info'>
              <div className='my-info-name'>{uidInfo.nickname}</div>
              <div className='my-info-id'>ID: {uidInfo.duid}</div>
            </div>
           </div>
          </div>
          <div className='my-ranking-card-right'>
            <div className='num'>{score(mine.score) || '--'}</div>
            <img className='num-icon' src='/img/app/ruby/icon_coin_gold-new.png'></img>
          </div>
          </div>}
        <Message ref="msg" />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/activity/eid-activities/index.js